import React, { useEffect } from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/error/error-3.scss";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export function ErrorPage3() {
	return (
		<div className="kt-grid kt-grid--ver kt-grid--root">
			<div
				className="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v3"
				style={{
					backgroundImage: `url(${toAbsoluteUrl("/media/error/bg3.jpg")})`,
				}}
			>
				<div className="kt-error_container">
					<div className="kt-error_number">
						<h1>403</h1>
					</div>
					<p className="kt-error_title kt-font-light">
						Parece que você não tem permissão
						<br />
						para acessar essa página.
					</p>
					<p className="kt-error_subtitle" style={{ cursor: "pointer" }}>
						<p onClick={() => window.location.href = '/dashboard'}>Voltar para dashboard</p>
						<Link to='/logout'>
							Sair
						</Link>
					</p>
				</div>
			</div>
		</div>
	);
}
